export default "__VITE_ASSET__07ad0dd3__"